import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import Fonts from './Fonts';
import Style from './Style';
import { ThemeProvider } from 'styled-components';
import { hollowPointsTheme } from './customTheme';
// import { lightTheme } from 'scorer-ui-kit';


// //let newTheme: any = lightTheme;
// let primary = newTheme.custom.lines.primary;

// primary.contrastLine.stroke =  primary.grabHandle.fill = primary.grabHandle.stroke = primary.grabHandleText.fill =  primary.handleBase.fill = primary.grabHandleContrast.stroke = primary.handleReactiveFill.fill = primary.highlightLine.stroke = primary.handleReactiveRing.stroke = primary.handleContrastLayer.stroke = primary.stopEnd.stopColor = primary.stopStart.stopColor = 'transparent';
// primary.point.fill = 'rgb(0, 0, 0, 0.8)';
// newTheme={ ...newTheme, custom: {...newTheme.custom, primary}};

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={hollowPointsTheme}>
      <App />
      <Fonts />
      <Style />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
